<tui-root tuiTheme="light">
  <router-outlet/>
</tui-root>
